import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {  MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';


import { Subscription } from 'rxjs/Subscription';

import { TranslationService } from '../translation.service';
import { Translation } from '../translation.model';
import { TranslationType } from '../translationtype.model';
import { CreateTranslationComponent } from '../create-translation/create-translation.component';
import * as _ from 'lodash';
@Component({
    selector: 'app-list-translation',
    templateUrl: './list-translation.component.html',
    styleUrls: ['./list-translation.component.css']
})

export class ListTranslationComponent implements OnInit, AfterViewInit {


    public translations: Translation[];
    public cacheTranslations: any;
    public translationtypes: TranslationType[];
    public p: number;
    private myAppUrl: string = "";
    private sortType: string;
    private sortReverse: boolean = false;
    private filteredTranslations: any;
    private selectedTranslation: Translation;
    public updateResponse: any;
    //@ViewChild('translationFilter') translationFilter: ElementRef;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    private baseUrl: string;
    public displayedColumns: string[] = ['translationId', 'original', 'translated', 'ignore', 'translationTypeName', 'actions'];
    public translationTableDataSource = new MatTableDataSource<Translation>();

    transSubscription: Subscription;
    transTypeSubscription: Subscription;
    constructor(private translationService: TranslationService, private dialog: MatDialog) {
    }

    ngOnInit() {
        this.transTypeSubscription = this.translationService.transTypeChanged.subscribe(transTypes => (this.translationtypes = transTypes));
        this.transSubscription = this.translationService.transChanged.subscribe(translations => {
            let array = translations.map(item => {
                let translationTypeName = this.getTranslationType(item.translationTypeId);
                return {
                    translationTypeName,
                    ...item
                };

            });
            this.setFilteredTranslation(array);
            this.cacheTranslations = array;
        }

        );
        this.translationService.fetchTranslationTypes();
        this.translationService.fetchTranslations();

        //this.allTranslations();

    }

    ngAfterViewInit() {
        this.translationTableDataSource.sort = this.sort;
        this.translationTableDataSource.paginator = this.paginator;
    }
    allTranslations() {
        if (this.translationService.getAvailableTranslations().length == 0) {
            this.translationService.getTranslations()
                .subscribe(result => {
                    this.translations = result
                    this.cacheTranslations = result;
                    this.setFilteredTranslation(result);
                    this.translationService.setAvailableTranslations(result);
                    //this.sortTranslations('translationId');
                }, error => console.error(error));
        }
        else {
            this.setFilteredTranslation(this.translationService.getAvailableTranslations());
        }
    }

    getTranslationType(searchKey: number) {
        try {
            if (this.translationtypes === undefined || searchKey === undefined || searchKey == 0 || searchKey == null)
                return "";
            else {
                return this.translationtypes.filter(ty => ty.translationTypeId == searchKey)[0].translationTypeName;
            }
        }
        catch{
            console.log(searchKey);
            return ""
        }
    }
    setFilteredTranslation(translations: any) {
        this.filteredTranslations = translations;
        this.translationTableDataSource.data = this.filteredTranslations;
    }

    ngOnDestroy() {
        this.transSubscription.unsubscribe();
    }

    //Filter for Translation Types
    filterForTypes(filterVal: any) {
        //this.translationFilter.nativeElement.value = '';
        if (filterVal === undefined || filterVal == "0") {
            this.filteredTranslations = this.cacheTranslations;
        }
        else {
            this.filteredTranslations = this.cacheTranslations.filter((item) => item.translationTypeId == filterVal);

        }
        this.translationTableDataSource.data = this.filteredTranslations;
        // this.filteredTranslations = this.translations
    }

    //Filter Translation 
    doFilter(filterValue: string) {
        this.translationTableDataSource.filter = filterValue.trim().toLowerCase();

    }
    update(row: any) {
        debugger;
        this.translationService.updateTranslaion({
            translationId: row.translationId,
            original: row.original,
            translated: row.translated,
            translationTypeId: row.translationTypeId,
            ignore: row.ignore
        });
    }

    onEdit(row) {
        row = _.omit(row, 'translationType')

        this.translationService.translationData = Object.assign({}, row);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "60%";
        this.dialog.open(CreateTranslationComponent, dialogConfig);
    }

    onCreate() {

        this.translationService.translationData = {
            translationId: null,
            original: '',
            translated: '',
            translationTypeId: null,
            ignore: false
        };
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "40%";
        this.dialog.open(CreateTranslationComponent, dialogConfig);

    }

    onDelete(transID) {
        if (confirm('Are you sure to delete this record ?')) {
            this.translationService.deleteTranslation(transID);
            //this.notificationService.warn('! Deleted successfully');
        }
    }

    onFtp() {
        this.translationService.getFiles();
    }

    onImportCSV() {
        this.translationService.onImportCSV();
    }

    onProcessTranslation() {
        this.translationService.onProcessTranslation();
    }
    onGDrive() {
        this.translationService.onGDrive();
    }

    onGenerateAds(feedID: string) {
        this.translationService.onGenerateAds(feedID);
    }
    //onSelect(prop: Translation): void {
    //  this.selectedTranslation = prop;
    //}

    //Updating  
    //updateTranslation() {
    //  this.http.put(this.myAppUrl + 'api/Translation/' + this.selectedTranslation.translationId, this.selectedTranslation).subscribe(result => {
    //    this.updateResponse = result
    //  }, error => console.error(error));
    //}
}

